<div class="flow-widget">
  <svg [attr.viewBox]="viewBox" class="flow-links" preserveAspectRatio="xMidYMid meet">
    @for (node of nodes; track node.id) {
      <path [attr.d]="node.path" [class]="'flow-line accent-' + node.accent" [class.is-active]="node.active"></path>
    }
    @for (node of nodes; track node.id) {
      @if (node.active) {
        @for (i of [0, 1, 2]; track i) {
          <circle
            r="4"
            [class]="'flow-dot accent-' + node.accent"
            [class.reverse]="node.direction === 'fromHub'"
            [style.offset-path]="'path(\'' + node.path + '\')'"
            [style.animation-duration.s]="node.duration"
            [style.animation-delay.s]="trailDelay(node.duration, i)"
          ></circle>
        }
      }
    }
  </svg>

  <div
    class="flow-node hub"
    [class.is-active]="hubActive"
    [style.left.%]="pct(hub.cx)"
    [style.top.%]="pct(hub.cy)"
    [style.width.%]="pct(hub.r * 2)"
    [style.height.%]="pct(hub.r * 2)"
    tabindex="0"
    role="link"
    (click)="navigateToMonitoring()"
    (keydown.enter)="navigateToMonitoring()"
  >
    <ion-icon name="home-outline"></ion-icon>
    <span class="flow-value">{{ hubValue | unitvalue:'kW' }}</span>
    <span class="flow-label">{{ 'GENERAL.CONSUMPTION' | translate }}</span>
  </div>

  @for (node of nodes; track node.id) {
    <div
      [class]="'flow-node accent-' + node.accent"
      [class.is-active]="node.active"
      [style.left.%]="pct(node.cx)"
      [style.top.%]="pct(node.cy)"
      [style.width.%]="pct(node.r * 2)"
      [style.height.%]="pct(node.r * 2)"
    >
      <ion-icon [name]="node.icon"></ion-icon>
      <span class="flow-value">{{ node.value | unitvalue:'kW' }}</span>
      @if (node.subText) {
        <span class="flow-subtext">{{ node.subText }}</span>
      }
      <span class="flow-label">{{ node.label | translate }}</span>
    </div>
  }
</div>
